<template>
  <div class="benefits_holder">
    <p class="benefits_item benefits_item__prem-tb" id="benefits_item__prem" @mouseover="onTrackHover">
      {{ $t('30 дней премиум аккаунта в подарок') }}
    </p>
    <p class="benefits_item benefits_item__gold" id="benefits_item__gold-tb" @mouseover="onTrackHover">
      <span v-if="cardType === CARD_TYPES.WB">{{ $t('10 золота за каждые 3 BYN, потраченных по карте') }}</span>
      <span v-else>{{ $t('9 золота за каждые 3 BYN, потраченных по карте') }}</span>
    </p>
    <p class="benefits_item benefits_item__percent-bonus-tb" id="benefits_item__percent_bonus" @mouseover="onTrackHover">
      <span>{{ $t('5% от стоимости покупок в Премиум магазине в виде золота') }}</span>
    </p>
  </div>
</template>

<script>
import { Component, Prop } from 'vue-property-decorator'
import BenefitsBase from '../BenefitsBase.vue'
import { CARD_TYPES } from '@/constants'

@Component
class BenefitsTbBy extends BenefitsBase {
  @Prop({ type: String }) cardType
  CARD_TYPES = CARD_TYPES
}

export default BenefitsTbBy
</script>
